module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "far fa-check-circle customCheck"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-2 font-weight-bold"
  }, [_vm._v("¡Se ha creado correctamente!")]), _vm._v(" "), _c('p', {
    staticClass: "px-4"
  }, [_vm._v("Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.")]), _vm._v(" "), _c('router-link', {
    staticClass: "font-weight-bold back",
    attrs: {
      "to": "/login/client"
    }
  }, [_vm._v("Ingresar")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f12a220a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Correct.vue
// module id = 1923
// module chunks = 1